import axios from "axios";
import { FC, useState } from "react";

const getTargetFileFromDB = async (url: string) => {
  console.log(`URL download : ` + url);

  const fileData = await axios({
    method: "get",
    url: url,
    responseType: "document",
  }).then((response) => {
    console.log(`response axios download
    1 >> ${JSON.stringify(response.data)}
    2 >> ${response.status}
    `);
    return response;
  });

  console.log(`response axios download 2
  1 >> ${JSON.stringify(fileData)}
  `);

  return new File([fileData.data], "test.csv");
};

const TargetTab: FC = () => {
  const [url, setUrl] = useState("");

  const downloadCSV = async () => {
    const file = await getTargetFileFromDB(
      "https://firebasestorage.googleapis.com/v0/b/days-stagging-5b2b7.appspot.com/o/campaigns%2FtKP63WDpdn8EKMbQsXvK%2Ftarget%2FCampaignTarget-Check-Send-2_23-Sep-2022%5B162036%5D.csv?alt=media&token=a4541888-bcc8-441d-8549-46a34cae72f8"
    );
  };

  return (
    <div className="d-flex space mb-5 mt-10">
      <input
        value={url}
        type="text"
        onChange={(e) => setUrl(e.target.value)}
      />
      <button type="button" className="btn btn-primary" onClick={downloadCSV}>
        Download
      </button>
    </div>
  );
};

export default TargetTab;
